export default __webpack_public_path__ + "static/logo-5b18ef9bc3c00cba6f45cd506802c9a1.jpg";